var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"cx":"24","cy":"24","r":"24","stroke":"#103C96","strokeWidth":".889","transform":"translate(1 1)","key":0}),React.createElement("path",{"d":"M35.752 25.832L20.555 35.964A1 1 0 0 1 19 35.13V14.87a1 1 0 0 1 1.555-.833l15.197 10.132a1 1 0 0 1 0 1.664z","fill":"#103C96","key":1})]));
}

Play.defaultProps = {};

module.exports = Play;

Play.default = Play;
